export default __webpack_public_path__ + "static/media/logo_footer.d29e2437.png";